module.exports = __webpack_public_path__ + "img/019-learning.ce53967d.svg";